import { Avatar } from "@/components/shared/Avatar";
import { TONE_TEXT } from "@/lib/widget-status";
import { cn } from "@/lib/utils";
import { HOST_STATUS_LABEL as STATUS_LABEL, type HostAvailability } from "@/lib/meeting-slots";

interface BookMeetingHostPickerProps {
  hosts: HostAvailability[];
  selectedId: string | null;
  onSelect: (userId: string) => void;
}

/** Vertene med ledighet: grønn «Ledig», grå «Opptatt» og grå stiplet uten kalendertilgang. */
export default function BookMeetingHostPicker({ hosts, selectedId, onSelect }: BookMeetingHostPickerProps) {
  if (hosts.length === 0) {
    return <p className="text-sm text-muted-foreground">Ingen er satt opp som verter ennå. Be en admin slå på «Kan bookes til kundemøte» under Brukere.</p>;
  }
  return (
    <ul className="grid gap-2 sm:grid-cols-3" aria-label="Verter">
      {hosts.map(({ host, status }) => {
        const selectable = status === "free";
        const selected = selectedId === host.user_id;
        return (
          <li key={host.user_id}>
            <button
              type="button"
              disabled={!selectable}
              aria-pressed={selected}
              aria-label={`${host.full_name}: ${STATUS_LABEL[status]}`}
              onClick={() => onSelect(host.user_id)}
              className={cn(
                "flex w-full items-center gap-2 border-[1.5px] p-2 text-left text-sm",
                selectable ? "border-foreground hover:bg-muted/50" : "border-muted-foreground/40 text-muted-foreground",
                (status === "no_access" || status === "unavailable") && "border-dashed",
                selected && "bg-foreground text-background hover:bg-foreground",
              )}
            >
              <Avatar name={host.full_name} avatarUrl={host.avatar_url} size="sm" />
              <span className="min-w-0">
                <span className="block truncate font-medium">{host.full_name}</span>
                <span className={cn("block text-xs", selectable && !selected && TONE_TEXT.reached)}>{STATUS_LABEL[status]}</span>
              </span>
            </button>
          </li>
        );
      })}
    </ul>
  );
}
